import AboutBlock from "./aboutBlock";

export default AboutBlock;